
export const commonEnv = {
  appVersion:'22.1',
  appName: "sky-tofes-mashkanta",
  apiTimeout: 10000,
  mizrahiPhone: '0768678887',
  mizrahiBankerPhone:'0768048860',
  mizrahiSupportPhone:'036011000',
  sessionTimeoutInMin:15,//device session
  printGALogs: false, //print ga logs
  whatsAppLink:'https://api.whatsapp.com/send/?phone=972768818860&text=%D7%94%D7%99%D7%99%2C+%D7%90%D7%A9%D7%9E%D7%97+%D7%9C%D7%A7%D7%91%D7%9C+%D7%A4%D7%A8%D7%98%D7%99%D7%9D+%D7%9C%D7%A7%D7%91%D7%9C%D7%AA+%D7%9E%D7%A9%D7%9B%D7%A0%D7%AA%D7%90&type=phone_number&app_absent=0',
};





// WEBPACK FOOTER //
// ./src/environments/environment.common.ts